module.exports = __webpack_public_path__ + "static/media/front.e3cee5e4.jpg";